import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormField from '../FormField';

abstract class FormFieldWithInitialValue extends FormField {
  initialValue;

  constructor(formFieldData: FormFieldsType, initialValue: any) {
    super(formFieldData);
    this.initialValue = initialValue;
  }
}

export default FormFieldWithInitialValue;
